var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex jc-center ai-end img-container pl-32",staticStyle:{"width":"100vmin","height":"100vmax"},attrs:{"id":"start"},on:{"click":_vm.startClick}},[_c('img',{staticClass:"to-right animate__animated animate__fadeInDown animate__infinite animate__delay-1s",attrs:{"src":require("../assets/img/toRight.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cba3b8a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/beforeStart.vue
// module id = null
// module chunks = 